import React from 'react';

interface ITextInputProps {
  label: string;
  value: string;
  setValue: (val: string) => void;
}

const TextInput = ({ label, value, setValue }: ITextInputProps) => {
  return (
    <div className="w-full">
      <textarea
        rows={3}
        value={value}
        placeholder="Enter custom label text..."
        className="w-full border border-[#c9cccf] rounded-md px-3 py-2 text-sm text-[#202223] placeholder:text-[#8c9196] focus:outline-none focus:ring-1 focus:ring-[#2563EB] focus:border-[#2563EB] transition-all resize-none bg-white hover:border-[#a6acb3]"
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );
};

export default TextInput;
